import { L10n, setCulture, setCurrencyCode } from "@syncfusion/ej2-base";

function setComponentsCulture(culture) {
	L10n.load({
		es: {
			grid: {
				EmptyRecord: "No hay registros que mostrar",
				True: "Verdadero",
				False: "Falso",
				InvalidFilterMessage: "Datos de filtro no válidos",
				GroupDropArea: "Arrastre el encabezado de una columna aquí para agrupar su columna",
				UnGroup: "Haga clic aquí para desagrupar",
				GroupDisable: "La agrupación está deshabilitada para esta columna",
				FilterbarTitle: "celda de barra de filtro",
				EmptyDataSourceError:
					"DataSource no debe estar vacío en la carga inicial ya que las columnas se generan a partir de dataSource en AutoGenerate Column Grid",
				Add: "Añadir",
				Edit: "Editar",
				Cancel: "Cancelar",
				Update: "Actualizar",
				Delete: "Eliminar",
				Print: "Impresión",
				Pdfexport: "Exportar PDF",
				Excelexport: "Exportación Excel",
				Wordexport: "Exportación de palabras",
				Csvexport: "Exportación CSV",
				Search: "Buscar",
				Columnchooser: "Columnas",
				Save: "Guardar",
				Item: "articulo",
				Items: "artículos",
				EditOperationAlert: "No hay registros seleccionados para la operación de edición",
				DeleteOperationAlert: "No hay registros seleccionados para la operación de eliminación",
				SaveButton: "Guardar",
				OKButton: "Ok",
				CancelButton: "Cancelar",
				EditFormTitle: "Detalles de",
				AddFormTitle: "Añadir nuevo récord",
				BatchSaveConfirm: "¿Seguro que quieres guardar los cambios?",
				BatchSaveLostChanges:
					"Los cambios no guardados se perderán. Estás seguro de que quieres continuar?",
				ConfirmDelete: "¿Estás seguro de que deseas eliminar el registro?",
				CancelEdit: "¿Estás seguro de que deseas cancelar los cambios?",
				ChooseColumns: "Elegir columna",
				SearchColumns: "columnas de búsqueda",
				Matchs: "No se encontraron coincidencias",
				FilterButton: "Filtrar",
				ClearButton: "Limpiar",
				StartsWith: "Comienza con",
				EndsWith: "Termina con",
				Contains: "Contiene",
				Equal: "Igual",
				NotEqual: "No es igual",
				LessThan: "Menos que",
				LessThanOrEqual: "Menor o igual",
				GreaterThan: "Mas grande que",
				GreaterThanOrEqual: "Mayor que o igual",
				ChooseDate: "Elige una fecha",
				EnterValue: "Ingrese el valor",
				Copy: "Copiar",
				Group: "Agrupar por esta columna",
				Ungroup: "Desagrupar por esta columna",
				autoFitAll: "Ajuste automático de todas las columnas",
				autoFit: "Ajustar automáticamente esta columna",
				Export: "Exportar",
				FirstPage: "Primera página",
				LastPage: "Última página",
				PreviousPage: "Pagina anterior",
				NextPage: "Siguiente página",
				SortAscending: "Ascendente",
				SortDescending: "Descendente",
				EditRecord: "Editar registro",
				DeleteRecord: "Eliminar el registro",
				FilterMenu: "Filtrar",
				SelectAll: "Seleccionar todo",
				Blanks: "Espacios en blanco",
				FilterTrue: "Verdadero",
				FilterFalse: "Falso",
				NoResult: "No se encontraron coincidencias",
				ClearFilter: "Limpiar filtro",
				NumberFilter: "Filtros de número",
				TextFilter: "Filtros de texto",
				DateFilter: "Filtros de fecha",
				DateTimeFilter: "Filtros de fecha y hora",
				MatchCase: "Match Case",
				Between: "Entre",
				CustomFilter: "Filtro personalizado",
				CustomFilterPlaceHolder: "Ingrese el valor",
				CustomFilterDatePlaceHolder: "Elige una fecha",
				AND: "Y",
				OR: "O",
				ShowRowsWhere: "Mostrar filas donde:",
				SortAtoZ: "Ordenar de A a Z",
				SortZtoA: "Ordenar de Z a A",
				SortByOldest: "Ordenar por más antigua",
				SortByNewest: "Ordenar por más nueva",
			},
			toast: {
				close: "Cerrar",
			},
			pager: {
				currentPageInfo: "{0} de {1} páginas",
				totalItemsInfo: "({0} artículos)",
				firstPageTooltip: "Ir a la primera página",
				lastPageTooltip: "Ir a la última página",
				nextPageTooltip: "Ir a la página siguiente",
				previousPageTooltip: "Regresar a la pagina anterior",
				nextPagerTooltip: "Ir al siguiente localizador",
				previousPagerTooltip: "Ir al localizador anterior",
				pagerDropDown: "Artículos por página",
				pagerAllDropDown: "Artículos",
				All: "Todos",
			},
		},
	});
	if (culture !== "en") {
		setCulture(culture);
		setCurrencyCode("UYU");
	}
}

export { setComponentsCulture };
